exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ciro-report-table[data-v-714af563]{width:100%;margin-top:4px}.ciro-report-table>*[data-v-714af563]{width:100%}", ""]);

// exports
